// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-body[data-v-70567e0d] {\n  height: 675px;\n}\n.modal-body .default-content[data-v-70567e0d] {\n  padding-top: 16px;\n}", ""]);
// Exports
module.exports = exports;
